//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "",
  components: {},
  data() {
    return {
      // 示例数据：
      // btnConfig: {
      //   list: [ {text:'返回', type: 'primary', action: () => this.$router.go(-1) } ],
      // },
    };
  },
  props: ["obj"],
  computed: {
  },
  methods: {
    onClick (item) {
      item.action();
    }
  }
};
